module.exports = __webpack_public_path__ + "img/logo.f68358d9.png";